import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useDeleteLeadForm = (options?: {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      return apiClient.delete(`lead-forms/${id}`);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['lead-forms'] });
      toast.success('Lead form archived');
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to archive lead form');
      options?.onError?.(error);
    },
  });

  return {
    deleteLeadForm: mutation.mutate,
    deleteLeadFormAsync: mutation.mutateAsync,
    isDeleting: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
  };
};
